import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";
import "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxDfIZBkavVQ_BFakuCFsw155cOY8rn2s",
  authDomain: "shinkanote.firebaseapp.com",
  projectId: "shinkanote",
  storageBucket: "shinkanote.appspot.com",
  messagingSenderId: "36366015242",
  appId: "1:36366015242:web:9ade706940475683df78f3",
  measurementId: "G-BXPB8J1LQX"
};

firebase.initializeApp(firebaseConfig);
const firebaseFunctions = firebase.functions;
const projectAuth = firebase.auth();
const projectFirestore = firebase.firestore();

if (window.location.hostname === "localhost") {
  console.log("localhost");
  projectFirestore.settings({
    host: "localhost:8080",
    ssl: false
  });
  projectAuth.useEmulator("http://localhost:9099");
}

const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { firebaseFunctions, projectFirestore, projectAuth, timestamp };
